module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( viewContext === "installer" ) { 
__p+=' <h5 data-title="customer-read" hidden>'+
((__t=( i18n.tc("CustomerLayout", "Please select an installer profile") ))==null?'':__t)+
'</h5> ';
 } 
__p+=' ';
 if ( viewContext === "customer" ) { 
__p+=' <h5 data-title="customer-read" hidden>'+
((__t=( i18n.tc("CustomerLayout", "Select an account to create a subscription") ))==null?'':__t)+
'</h5> ';
 } 
__p+=' ';
 if ( viewContext === "billing" ) { 
__p+=' <h5 data-title="customer-read" hidden>'+
((__t=( i18n.tc("CustomerLayout", "Billing accounts") ))==null?'':__t)+
'</h5> ';
 } 
__p+=' <div data-region="customer-container"></div> ';
 if ( hasCreate ) { 
__p+=' <fieldset class="button-wrap text-left"><small><a href="#" data-click="customer-create">'+
((__t=( i18n.tc("CustomerLayout", "Create new billing account?") ))==null?'':__t)+
'</a></small></fieldset> ';
 } 
__p+=' <fieldset class="button-wrap"><button data-click="customer-cancel">'+
((__t=( i18n.tc("CustomerLayout", "Cancel") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
